import axios from 'axios';

const authApi = axios.create({
  // baseURL: "https://api2.dogtrack.io",
  baseURL: process.env.REACT_APP_API,
});

export default authApi;
